/* eslint-disable prettier/prettier */
/* eslint-disable prettier/prettier */
import React, {
	createContext,
	useState,
	ReactNode,
	useContext,
	useMemo,
} from 'react';

interface HeaderContextType {
	headerContent: ReactNode | null;
	setHeaderContent: (content: ReactNode | null) => void;
	isOverridden: boolean;
}

const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

export const HeaderProvider: React.FC<{ children: ReactNode }> = ({
	children,
}) => {
	const [headerContent, setHeaderContent] = useState<ReactNode | null>(null);

	const value = useMemo(() => {
		return {
			headerContent,
			setHeaderContent,
			isOverridden: headerContent !== null,
		};
	}, [headerContent]);

	return (
		<HeaderContext.Provider value={value}>
			{children}
		</HeaderContext.Provider>
	);
};

export const useHeader = () => {
	const context = useContext(HeaderContext);
	if (!context) {
		throw new Error('useHeader must be used within a HeaderProvider');
	}
	return context;
};
